import app from '../../forum/app';
import Component from '../../common/Component';
import Button from '../../common/components/Button';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import Placeholder from '../../common/components/Placeholder';
import classList from '../../common/utils/classList';
import PostListItem from './PostListItem';
export default class PostList extends Component {
  view() {
    const state = this.attrs.state;
    const params = state.getParams();
    const isLoading = state.isInitialLoading() || state.isLoadingNext();
    let loading;
    if (isLoading) {
      loading = m(LoadingIndicator, null);
    } else if (state.hasNext()) {
      loading = m(Button, {
        className: "Button",
        onclick: state.loadNext.bind(state)
      }, app.translator.trans('core.forum.post_list.load_more_button'));
    }
    if (state.isEmpty()) {
      return m("div", {
        className: "PostList"
      }, m(Placeholder, {
        text: app.translator.trans('core.forum.post_list.empty_text')
      }));
    }
    const pageSize = state.pageSize || 0;
    return m("div", {
      className: classList('PostList', {
        'PostList--searchResults': state.isSearchResults()
      })
    }, m("ul", {
      role: "feed",
      "aria-busy": isLoading,
      className: "PostList-discussions"
    }, state.getPages().map((pg, pageNum) => {
      return pg.items.map((post, itemNum) => m("li", {
        key: post.id(),
        "data-id": post.id(),
        role: "article",
        "aria-setsize": "-1",
        "aria-posinset": pageNum * pageSize + itemNum + 1
      }, m(PostListItem, {
        post: post,
        params: params
      })));
    })), m("div", {
      className: "PostList-loadMore"
    }, loading));
  }
}
flarum.reg.add('core', 'forum/components/PostList', PostList);